import { showAsFree } from 'owa-locstrings/lib/strings/showasfree.locstring.json';
import { showAsWorkingElsewhere } from 'owa-locstrings/lib/strings/showasworkingelsewhere.locstring.json';
import { showAsAway } from 'owa-locstrings/lib/strings/showasaway.locstring.json';
import { showAsTentative } from 'owa-locstrings/lib/strings/showastentative.locstring.json';
import { showAsBusy } from 'owa-locstrings/lib/strings/showasbusy.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { getFreeBusyItemBarStyling, getFreeBusyStripClass, FreeBusyType } from 'owa-freebusy-style';

import { registerIcons } from '@fluentui/react/lib/Styling';
import { getDefaultColorSchemes } from 'owa-calendar-color-resolver';

import styles from './generateShowAsItems.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

const showAsOptions = [
    { key: 'Free', text: loc(showAsFree) },
    { key: 'WorkingElsewhere', text: loc(showAsWorkingElsewhere) },
    { key: 'Tentative', text: loc(showAsTentative) },
    { key: 'Busy', text: loc(showAsBusy) },
    { key: 'OOF', text: loc(showAsAway) },
];

export const generateShowAsItems = (
    item: CalendarEvent,
    onClick: (freeBusy: FreeBusyType) => void,
    colorScheme: ColorScheme
): IContextualMenuItem[] => {
    return showAsOptions.map(option => ({
        key: option.key,
        name: option.text,
        onClick: () => onClick(option.key as FreeBusyType),
        checked: option.key == item.FreeBusyType,
        canCheck: true,
        onRenderIcon: () => renderIcon(option.key as FreeBusyType, colorScheme),
    }));
};

function renderIcon(freeBusyType: FreeBusyType, colorScheme: ColorScheme) {
    const freeBusyStyling = getFreeBusyItemBarStyling(freeBusyType, colorScheme);
    const freeBusyClass = getFreeBusyStripClass(freeBusyType);

    return <div className={classNames(styles.showAsItem, freeBusyClass)} style={freeBusyStyling} />;
}

function renderShowAsIcon(freeBusyType: FreeBusyType) {
    const colorScheme = getDefaultColorSchemes()[0];
    return renderIcon(freeBusyType, colorScheme);
}

function ShowAsFreeIcon() {
    return renderShowAsIcon('Free');
}

function ShowAsWorkingElsewhereIcon() {
    return renderShowAsIcon('WorkingElsewhere');
}

function ShowAsTentativeIcon() {
    return renderShowAsIcon('Tentative');
}

function ShowAsBusyIcon() {
    return renderShowAsIcon('Busy');
}

function ShowAsOOFIcon() {
    return renderShowAsIcon('OOF');
}

registerIcons({
    icons: {
        ShowAsFreeIcon: <ShowAsFreeIcon />,
        ShowAsWorkingElsewhereIcon: <ShowAsWorkingElsewhereIcon />,
        ShowAsTentativeIcon: <ShowAsTentativeIcon />,
        ShowAsBusyIcon: <ShowAsBusyIcon />,
        ShowAsOOFIcon: <ShowAsOOFIcon />,
    },
});

export const chosenShowAsOptionText = (item: CalendarEvent) =>
    showAsOptions.filter(option => option.key == item.FreeBusyType)[0].text;
